"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgHistory(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M20 0v2h-2.034c.17.277.268.48.268.824a1.8 1.8 0 01-.285.968L15.265 8l2.684 4.208c.387.607.368 1.22.017 1.792H20v2H4v-2h2.034c-.17-.277-.268-.48-.268-.824a1.8 1.8 0 01.285-.968L8.733 8 6.05 3.792c-.387-.607-.368-1.22-.017-1.792H4V0zm-3.766 3H7.766l3.3 5-3.3 5h8.468l-3.301-5 3.3-5zM12 9l2 3h-4z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('History')(SvgHistory);
//# sourceMappingURL=History.js.map